export default __webpack_public_path__ + "static/CustomizedToYourPatients-41f00c060d9b2a94184eaeef21f26b17.jpg";